import React, { Component } from 'react';
import AnswerButton from '../../../AnswerButton/AnswerButton';
import logo from '../../../../images/LOGO_PATHE.png';
import Config from "../../../../config/config";

export default class QuestionDevice extends Component {

	constructor(props) {
		super(props);

		this.state = { clicked: false };
		console.log("QuestionDevice:", props.question);
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Question',
			'page_path': '/question'
		});
	}

	onClick(e) {
		this.setState({ clicked: true, answer_id: e.id });
		this.props.onClick(e.target);
	}

	findAnswer(id) {
		for (var i=this.props.question.Answers; i--;) {
			if (this.props.question.Answers[i].id === id) {
				return this.props.question.Answers[i];
			}
			console.log("ERROR: unknown ID!");
		}
	}

	getThemeStyle(questionConfig) {
		let themeStyle = {};

		themeStyle.topLogoImage = questionConfig.theme_device_top_logo ? questionConfig.theme_device_top_logo : logo;
		themeStyle.bottomLogoStyle = questionConfig.theme_device_bottom_logo ? {backgroundImage: "url('" + questionConfig.theme_device_bottom_logo + "')"} : null;
		themeStyle.curtainsStyle = questionConfig.theme_device_curtains ? {backgroundImage: "url('" + questionConfig.theme_device_curtains + "')"} : null;

		themeStyle.screenStyle = {};
		if (questionConfig.theme_device_font) themeStyle.screenStyle.fontFamily = questionConfig.theme_device_font;
		if (questionConfig.theme_device_text_color) themeStyle.screenStyle.color = "#" + questionConfig.theme_device_text_color;
		if (questionConfig.theme_device_background_image) {
			themeStyle.screenStyle.backgroundImage = "url('" + questionConfig.theme_device_background_image + "')";
			themeStyle.screenStyle.position = "absolute";		
			themeStyle.screenStyle.height = "100vh";
			themeStyle.screenStyle.backgroundSize = "contain";
		}

		themeStyle.buttonStyle = {};
		if (questionConfig.theme_device_button_text_color) themeStyle.buttonStyle.color = "#" + questionConfig.theme_device_button_text_color;
		if (questionConfig.theme_device_button_border_color) themeStyle.buttonStyle.borderColor = "#" + questionConfig.theme_device_button_border_color;
		if (questionConfig.theme_device_button_background_color) themeStyle.buttonStyle.backgroundColor = "#" + questionConfig.theme_device_button_background_color;

		return themeStyle;
	}

	render() {
		let question = "";
		let answers = null;
		let audioDiv = null;
		console.log("Question::render:", this.props.question);
		let themeStyle = {
			buttonStyle: {},
			screenStyle: {},
		}; 
		if (this.props.question) {
			themeStyle = this.getThemeStyle(this.props.question);
			question = this.props.question.question;
			if (this.props.question.answer) {
				answers = this.props.question.Answers.slice(0,4).map(
					(a, index) => { return <AnswerButton key={index} answer={a} questionTimerFinished={this.props.questionTimerFinished} onClick={this.onClick.bind(this)} style={themeStyle.buttonStyle}/> }
				);
			}
			audioDiv = this.props.question.question_device_audio ? <audio src={this.props.question.question_device_audio} autoPlay="true" /> : null;			
		}
		const body = <div className="question">
			{question}<br /><br />
			<div className="answers">
				{answers}
			</div>
		</div>;

		return (
			<div className="container" style={themeStyle.screenStyle}>
				<div className="logo"><img src={themeStyle.topLogoImage} width="100%" alt="logo" /></div>
				<div className="question">
					{body}
					<div className="curtains" style={themeStyle.curtainsStyle}></div>
					{audioDiv}
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/pages/Quiz/QuestionDevice/QuestionDevice.js